/** English landing hero */
export const SPLINE_LANDING_SCENE_EN =
  'https://my.spline.design/motiontrails-qudAAEnqArzAjycx7IJNSTq4/';

/** Georgian landing hero — Motion Trails Copy */
export const SPLINE_LANDING_SCENE_KA =
  'https://my.spline.design/motiontrailscopy-1OYFFR0oSiL37aWZgSd7CfTK/';

const isSplineEmbedUrl = (url) => {
  if (!url) return false;
  return url.trim().toLowerCase().includes('my.spline.design');
};

export const isGeorgianLocale = (language) => {
  const code = (language || 'en').split('-')[0].toLowerCase();
  return code === 'ka';
};

/** @splinetool/react-spline only accepts prod .splinecode URLs */
export const isReactSplineScene = (url) => {
  if (!url) return false;
  const trimmed = url.trim().toLowerCase();
  if (trimmed.includes('my.spline.design')) return false;
  if (trimmed.startsWith('/')) return false;
  return (
    trimmed.includes('.splinecode') || trimmed.includes('prod.spline.design')
  );
};

/** Append ?v=… so browsers refetch after you re-export the same Spline URL */
export const appendSplineCacheBust = (url) => {
  const trimmed = (url || '').trim();
  if (!trimmed) return trimmed;

  const bust = process.env.REACT_APP_SPLINE_CACHE_BUST?.trim();
  if (!bust) return trimmed;

  const separator = trimmed.includes('?') ? '&' : '?';
  return `${trimmed}${separator}v=${encodeURIComponent(bust)}`;
};

export const getSplineLandingSceneEn = () => {
  const fromEnv = process.env.REACT_APP_SPLINE_LANDING_URL?.trim();
  return appendSplineCacheBust(fromEnv || SPLINE_LANDING_SCENE_EN);
};

export const getSplineLandingSceneKa = () => {
  const fromEnv = process.env.REACT_APP_SPLINE_LANDING_URL_KA?.trim();
  return appendSplineCacheBust(fromEnv || SPLINE_LANDING_SCENE_KA);
};

export const getSplineLandingScene = (language) => {
  const scene = isGeorgianLocale(language)
    ? getSplineLandingSceneKa()
    : getSplineLandingSceneEn();

  if (process.env.NODE_ENV === 'development') {
    const en = getSplineLandingSceneEn();
    const ka = getSplineLandingSceneKa();
    if (isSplineEmbedUrl(en) || isSplineEmbedUrl(ka)) {
      console.warn(
        '[Hero] Landing scenes use my.spline.design iframe embeds. Export each scene as a .splinecode URL in Spline (Export → Code) and set REACT_APP_SPLINE_LANDING_URL / _KA for custom cursor + mouse interaction together.'
      );
    }
    if (en && ka && en === ka) {
      console.warn(
        '[Hero] English and Georgian Spline URLs are identical — both languages will show the same scene. Set different REACT_APP_SPLINE_LANDING_URL and REACT_APP_SPLINE_LANDING_URL_KA in .env'
      );
    }
    if (isGeorgianLocale(language) && !scene) {
      console.warn(
        '[Hero] REACT_APP_SPLINE_LANDING_URL_KA is missing — paste the export URL from your Georgian Spline file.'
      );
    }
  }

  return scene;
};
